import { render } from "./DefaultLandingPage.vue?vue&type=template&id=baad8c7e"
import script from "./DefaultLandingPage.vue?vue&type=script&lang=js"
export * from "./DefaultLandingPage.vue?vue&type=script&lang=js"

import "./DefaultLandingPage.vue?vue&type=style&index=0&id=baad8c7e&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__